import Icon from '@forwardflow/ui/Icons'

export const AutoNurtureImpact = ({ analytics }: { analytics: any }) => {
   return (
      <>
         <div className="bg-[#3B3C42] mb-4 rounded">
            <p className="px-8 py-5 border-b border-white/20 text-[14px]">
               Auto nurture
               <span className="text-[12px] pl-2">
                  Impact View the change after auto-nurturing
               </span>
            </p>
            <div className="flex flex-wrap">
               {analytics?.projectedConversionStats?.conversionRatePercent
                  ?.projected != null &&
                  analytics?.projectedConversionStats?.conversionRatePercent
                     ?.projected !== 0 && (
                     <div className="flex-1 py-5 px-7">
                        <p className="text-white/70 text-[14px] font-medium mb-1">
                           Conversion Rate
                        </p>
                        <div className="flex items-center gap-x-2">
                           <span className="text-[24px] font-medium">
                              {analytics?.conversionStats?.conversionRatePercent
                                 ? `${analytics.conversionStats.conversionRatePercent.toFixed(
                                      2
                                   )}%`
                                 : 'N/A'}{' '}
                           </span>
                           {analytics?.projectedConversionStats
                              ?.conversionRatePercent?.projected != null &&
                              analytics?.projectedConversionStats
                                 ?.conversionRatePercent?.projected !== 0 && (
                                 <div className="w-16 px-10 rounded h-7 flexc bg-black/20 gap-x-2">
                                    {analytics?.projectedConversionStats
                                       ?.conversionRatePercent
                                       ?.changeInPercent > 0 ? (
                                       <Icon
                                          name="GreenArrow"
                                          className="scale-110"
                                       />
                                    ) : (
                                       <Icon
                                          name="GreenArrow"
                                          className="scale-110 rotate-180"
                                       />
                                    )}

                                    <span className="whitespace-nowrap">
                                       {analytics?.projectedConversionStats?.conversionRatePercent?.projected?.toFixed(
                                          2
                                       )}{' '}
                                       %
                                    </span>
                                 </div>
                              )}
                        </div>
                     </div>
                  )}

               <div className="flex-1 py-5 px-7">
                  <p className="text-white/70 text-[14px] font-medium mb-1">
                     Speed to Action
                  </p>
                  <div className="flex items-center gap-x-2">
                     <span className="text-[24px] font-medium">
                        {analytics?.projectedConversionStats?.avgSpeedToAction
                           ?.change || '1 week'}
                     </span>

                     <div className="px-2 rounded h-7 flexc bg-black/20 gap-x-2">
                        <Icon name="GreenArrow" className="scale-110" />

                        <span>
                           {analytics?.projectedConversionStats
                              ?.avgSpeedToAction?.projected ?? '5 minutes'}
                        </span>
                     </div>
                  </div>
               </div>
               {analytics?.projectedConversionStats?.responseRatePercent
                  ?.projected != null &&
                  analytics?.projectedConversionStats?.responseRatePercent
                     ?.projected !== 0 && (
                     <div className="flex-1 py-5 px-7">
                        <p className="text-white/70 text-[14px] font-medium mb-1">
                           Response rate
                        </p>
                        <div className="flex items-center gap-x-2">
                           <span className="text-[24px] font-medium">
                              {analytics?.conversionStats?.responseRatePercent
                                 ? `${analytics.conversionStats.responseRatePercent.toFixed(
                                      2
                                   )}%`
                                 : 'N/A'}
                           </span>
                           {analytics?.projectedConversionStats
                              ?.responseRatePercent?.projected != null &&
                              analytics?.projectedConversionStats
                                 ?.responseRatePercent?.projected !== 0 && (
                                 <div className="w-16 px-10 rounded h-7 flexc bg-black/20 gap-x-2">
                                    {analytics?.projectedConversionStats
                                       ?.responseRatePercent?.changeInPercent >
                                    0 ? (
                                       <Icon
                                          name="GreenArrow"
                                          className="scale-110"
                                       />
                                    ) : (
                                       <Icon
                                          name="GreenArrow"
                                          className="scale-110 rotate-180"
                                       />
                                    )}

                                    <span className="whitespace-nowrap">
                                       {analytics?.projectedConversionStats?.responseRatePercent?.projected?.toFixed(
                                          2
                                       )}{' '}
                                       %
                                    </span>
                                 </div>
                              )}
                        </div>
                     </div>
                  )}
            </div>
         </div>
      </>
   )
}

export default AutoNurtureImpact
